<div class="flex-fill ui-create-page edge-edit" *ngrxLet="selectActiveLevel2$; let activeLevel2">
  <div class="h-100 w-100">
    <ui-header-with-breadcrumbs>
      <div class="flex-row end-center gap-10">
        <ui-button *ngIf="
              activeLevel2 === menuKeys.configuration"
                            [loading]="selectIsSaving$ | ngrxPush"
                            [text]="'COMMON.SAVE'|translate"
                            (clickAction)="save()"
        >
        </ui-button>
        <ui-button *ngIf="
              activeLevel2 === menuKeys.details"
                            [loading]="selectIsSaving$ | ngrxPush"
                            [text]="'COMMON.SAVE'|translate"
                            [disabled]="activeLevel2 === menuKeys.details && !(selectIsLocationDetailsFormValid$ | async)"
                            (clickAction)="save()"
        >
        </ui-button>
        <ui-button
          *ngIf="
              activeLevel2 === menuKeys.speakers
        "
          [loading]="selectIsSaving$ | ngrxPush"
          [text]="'LOCATION_EDIT.ADD_SPEAKER'|translate"
          class="add-speaker-button"
          (clickAction)="addSpeaker()"
        >
        </ui-button>
        <ng-container *ngrxLet="selectDeviceState$; let deviceState">
          <ui-button
            *ngIf="
              activeLevel2 === menuKeys.addSpeaker
        "
            [disabled]="!deviceState?.testSuccess"
            [loading]="selectIsSaving$ | ngrxPush"
            [text]="'COMMON.SAVE'|translate"
            (clickAction)="create()"
          >
          </ui-button>
          <ui-button
            type="primary"
            *ngIf="
              activeLevel2 === menuKeys.addSensor
        "
            [disabled]="!deviceState?.testSuccess"
            [loading]="selectIsSaving$ | ngrxPush"
            (clickAction)="create()"
          >{{ isCreate ? ('LOCATION_EDIT.CREATE_SENSOR'|translate) : ('COMMON.SAVE'|translate) }}
          </ui-button>
        </ng-container>

        <ui-button
          *ngIf="
              activeLevel2 === menuKeys.appleTvListEdit
        "
          [loading]="selectIsSavingAppleTV$ | ngrxPush"
          [disabled]="!(selectIsFormValid$|ngrxPush)"
          [text]="'LOCATION_EDIT.SAVE_STREAM'|translate"
          (clickAction)="create()"
        >
        </ui-button>
        <ui-button
          *ngIf="
              activeLevel2 === menuKeys.appleTvListCreate
        "
          [loading]="selectIsSavingAppleTV$ | ngrxPush"
          [disabled]="!(selectIsFormValid$|ngrxPush)"
          [text]="'LOCATION_EDIT.CREATE_STREAM'|translate"
          (clickAction)="create()"
        >
        </ui-button>

        <ui-button
          *ngIf="
              activeLevel2 === menuKeys.externalStorageEdit
        "
          [loading]="selectIsSavingExternalStorage | ngrxPush"
          [disabled]="!(selectIsExternalStorageFormValid$|ngrxPush)"
          [text]="'LOCATION_EDIT.SAVE_EXTERNAL_STORAGE'|translate"
          (clickAction)="create()"
        >
        </ui-button>
        <ui-button
          *ngIf="
              activeLevel2 === menuKeys.remoteIosEdit
        "
          [loading]="selectIsSavingRemoteIO | ngrxPush"
          [disabled]="!(selectIsRemoteIOFormValid$|ngrxPush)"
          [text]="'LOCATION_EDIT.SAVE_REMOTE_IO'|translate"
          (clickAction)="create()"
        >
        </ui-button>
      </div>
    </ui-header-with-breadcrumbs>
    <div class="ui-router-wrapper flex-row">
      <ui-menu-level2 *ngIf="activeLevel2 !== menuKeys.sensorView"></ui-menu-level2>
      <div class="router-content w-100">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
